export const environment = {
  key: 'dev',
  production: false,
  googleAuthClientId: '976631720987-5tbcpb2e9jsl9qs3a8bvorm48n99aple.apps.googleusercontent.com',
  googleApiKey: 'AIzaSyBSSR0wLkGWq9yaCOKSZVrloFs4cXmwR_g',// #gitleaks:allow
  baseUrl: 'https://dev.polaris.internal.noovle.com',
  buildTimestamp: '2025-06-16 15.04.44 UTC',
  microsoft:{
    clientId: '8fa62736-cb64-4e20-aa81-07749390fa0d',
    tenantId: 'https://login.microsoftonline.com/6815f468-021c-48f2-a6b2-d65c8e979dfb'
  }
};
